<template>
    <v-container class="fill-height align-start align-content-start">
        <v-row class="mb-4 mt-12">
            <v-col cols="12" class="d-flex flex-row align-center">
                <h2 class="page-title">Модели</h2>
                <a class="page-title" href="/task/">Расчеты</a>
                <v-spacer></v-spacer>
                <v-btn large color="primary" dark elevation="0" @click="gotoNew">
                    Новая модель
                </v-btn>
            </v-col>
        </v-row>
        <v-row align="start" :justify="isEmpty || isLoading ? 'center' : 'start'">
            <v-col cols="12">
                <v-data-table
                        dense
                        dark
                        :headers="headers"
                        :items="items"
                        :loading="isLoading"
                        :items-per-page="itemsPerPage"
                        multi-sort
                        :sort-by="['created']"
                        :sort-desc="[true]"
                        locale="ru"
                        :footer-props="{'items-per-page-options': [5, 15, 50, 100, 500, -1]}"
                        @update:items-per-page="newValue => itemsPerPage = newValue"
                >
                    <template #item.updated="{item}">
                        {{getUpdated(item)}}
                    </template>
                    <template #item.status="{item}">
                        {{getStatusText(item)}}
                    </template>
                    <template #item.tasks="{item}">
                        <v-tooltip
                            v-for="task in getTasks(item)"
                            :key="task.id"
                            :open-on-hover="true"
                            color="white"
                            bottom
                        >
                            <p class="mb-0">Прогресс: {{ task.progress }}%</p>
                            <p class="mb-0">Статус: {{ task.status }}</p>
                            <p class="mb-0">Шаг: {{ task.step_number }}</p>
                            <p class="mb-0">Инфляционный фактор: {{ task.inflation_factor }}</p>
                            <p class="mb-0" v-if="task.error">Ошибка: {{ task.error }}</p>
                            <template #activator="{ on, attrs }">
                                <v-chip
                                    v-bind="attrs"
                                    v-on="on"
                                    color="white"
                                    text-color="primary"
                                    class="mr-2"
                                    small
                                    @click="gotoTask(task)"
                                >
                                    {{getTypeTitle(task)}}
                                    <span v-if="task.progress > 0 && !task.error && task.status !== 'finished'">
                                        ({{task.progress}}%)
                                        <v-progress-circular
                                            :size="16"
                                            :width="2"
                                            indeterminate
                                            color="primary"
                                            class="ml-2"
                                        ></v-progress-circular>
                                    </span>
                                </v-chip>
                            </template>
                        </v-tooltip>
                    </template>
                    <template #item.actions="{ item }">
                        <v-btn color="primary" x-small @click="gotoNewTask(item)" class="mr-4 elevation-0">
                            <v-icon x-small>mdi-calculator</v-icon> Новый расчет
                        </v-btn>
                        <v-btn icon small @click="gotoEdit(item.id)"><v-icon>mdi-pencil</v-icon></v-btn>
                        <v-btn icon small @click="downloadJson(item)"><v-icon>mdi-download</v-icon></v-btn>
                        <v-btn icon small @click="copy(item)"><v-icon>mdi-content-copy</v-icon></v-btn>
                        <v-btn icon small @click="gotoCalculations(item)" class="ml-2" v-if="isCalculationReady(item)"><v-icon>mdi-eye</v-icon></v-btn>
                        <v-btn icon small @click="deleteItem(item)" class="ml-4"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog
            v-model="editDialog"
            max-width="50%"
        >
            <new-form v-model="editedItem" @save="save" @close="cancelEdit"></new-form>
        </v-dialog>

    </v-container>
</template>

<script>
    import CrudList from "@/components/CrudList";
    import NewForm from "@/components/Problem/NewForm";
    import clone from "lodash.clonedeep";
    import {truncate, downloadJson} from "@/utils";
    import moment from "moment";
    import problem from "@/store/modules/problem";

    export default {
        extends: CrudList,
        components: {NewForm},
        data() {
            return {
                isLoading: false,
                headers: [
                    {text: 'Имя', value: 'name'},
                    {text: 'Обновлено', value: 'updated'},
                    {text: 'Задачи', value: 'tasks'},
                    {text: 'Действия', value: 'actions', sortable: false},
                ],

                ACTION_NEW: 'problem/newItem',
                ACTION_SAVE: 'problem/saveItem',
                ACTION_LOAD: 'problem/loadItems',
                ACTION_DELETE: 'problem/deleteItem',
                ROUTE_EDIT: 'problemEdit',
                ROUTE_NEW: 'problemNew',
                STORE_MODULE: 'problem',
                editedItem: null,
                editDialog: false,
                deleteDialog: false,
                itemsPerPage: 15,
            }
        },
        created() {
            this.loadState();
        },
        async mounted() {
            await this.loadItems();
            await this.$store.commit('task/setEditItem', null);
            await this.$store.commit('problem/setEditItem', null);
        },
        watch: {
            routeToProblem() {
                if (this.routeToProblem) {
                    this.$router.push({name: 'problemEdit', params: {id: this.routeToProblem.id, step: 'problem'}});
                }
            },
            itemsPerPage() {
                this.saveState();
            }
        },
        methods: {
            async loadItems() {
                this.isLoading = true;
                await this.$store.dispatch(this.ACTION_LOAD);
                this.isLoading = false;
            },
            async gotoCalculations(item) {
                return this.$router.push({name: 'viewResult', params: {id: item.id}});
            },
            gotoEdit(id) {
                this.$router.push({name: this.ROUTE_EDIT, params: {id, step: 'problem'}});
            },
            gotoTask(task) {
                if (!task) {
                    return;
                }

                if (task.status !== 'finished') {
                    this.$router.push({ name: 'taskProgress', params: { id: task.id } });
                    return;
                }

                if (task.type === 'adapt') {
                    return this.gotoAdaptResult(task);
                }
                else if (task.type === 'predict') {
                    return this.gotoPredictResult(task);
                }
            },
            gotoAdaptResult(task) {
                this.$router.push({ name: 'adaptResult', params: { id: task.id } });
            },
            gotoPredictResult(task) {
                this.$router.push({ name: 'viewResult', params: { id: task.id } });
            },
            gotoNewTask(problem) {
                this.$router.push({ name: 'taskNew', params: {id: problem.id} });
            },
            async save() {
                let item = clone(this.editedItem);
                if (item?.problem) {
                    item = problem;
                }

                if (item._id) {
                    delete item._id;
                }

                await this.$store.dispatch(this.ACTION_NEW, {problem: item, state: null});

                this.editDialog = false;
                this.editedItem = null;
            },
            async copy(item) {
                await this.$store.dispatch('problem/copyItem', item['id']);
                await this.loadItems();
            },
            cancelEdit() {
                this.editedItem = {};
                this.editDialog = false;
            },
            gotoNew() {
                this.editedItem = {};
                this.editDialog = true;
            },
            downloadJson(item) {
                downloadJson(item);
            },
            getUpdated(problem) {
               return moment(problem.updated * 1000).format('DD.MM.YYYY HH:mm');
            },
            getStatus(problem) {
                if (!problem.tasks || problem?.tasks?.length === 0) {
                    return {code: "edit", text: "Ввод данных"};
                }

                let taskStatuses = problem?.tasks?.map(task => task.status);
                let taskTypes = problem?.tasks?.map(task => task.type);

                let hasErrors = taskStatuses.includes('error');
                if (hasErrors) {
                    return {code: "error", text: "Ошибка"};
                }

                if (problem.type === 'base') {
                    let hasOptimizeTask = taskTypes.includes('optimize');
                    let hasPredictTask = taskTypes.includes('predict');

                    let isOptimizeFinished = hasOptimizeTask && problem.tasks.find(task => task.type === 'optimize')?.status === 'finished';
                    let isPredictFinished = hasPredictTask && problem.tasks.find(task => task.type === 'predict')?.status === 'finished';

                    if (!isOptimizeFinished) {
                        return {code: "adapt", text: "Адаптация"};
                    }

                    if (!isPredictFinished) {
                        return {code: "predict", text: "Прогноз"};
                    }

                    if (isOptimizeFinished && isPredictFinished) {
                        return {code: "finished", text: "Завершена"};
                    }
                }
                else if (problem.type === 'wells') {
                    let hasWellsTask = taskTypes.includes('wells');
                    let hasPredictTask = taskTypes.includes('predict');

                    let isWellsFinished = hasWellsTask && problem.tasks.find(task => task.type === 'wells')?.status === 'finished';
                    let isPredictFinished = hasPredictTask && problem.tasks.find(task => task.type === 'predict')?.status === 'finished';

                    if (!isWellsFinished) {
                        return {code: "wells", text: "Расстановка скважин"};
                    }

                    if (!isPredictFinished) {
                        return {code: "predict", text: "Прогноз"};
                    }

                    if (isWellsFinished && isPredictFinished) {
                        return {code: "finished", text: "Завершена"};
                    }
                }

                return {code: "unknown", text: "Неизвестно"};
            },
            getStatusText(problem) {
                let status = this.getStatus(problem);
                return status.text;
            },
            getTypeTitle(problem) {
                let type = this.analysisTypes.find(analysisType => analysisType.code === problem.type);
                if (!type) {
                    return "";
                }

                return type?.shortTitle || '';
            },
            getTasks(problem) {
                let allowedTypes = this.$store.state.problem.analysisTypes.map(type => type.code);
                return (problem?.tasks || [])
                    .filter(task => allowedTypes.includes(task.type))
            },
            isCalculationReady(item) {
                return !['edit', 'error'].includes(this.getStatus(item).code);
            },
            saveState() {
                const state = {
                    itemsPerPage: this.itemsPerPage
                }

                localStorage.setItem('problem_list_state', JSON.stringify(state));
            },
            loadState() {
                let savedState = localStorage.getItem('problem_list_state');
                if (savedState) {
                    let state = JSON.parse(savedState);
                    this.itemsPerPage = state.itemsPerPage;
                }
            },
            getNewItem(srcItem) {
                let item = srcItem?.problem ? srcItem?.problem : srcItem;
                item['name'] = truncate(item['name'], 48);
                item['tasks'] = srcItem?.tasks || [];
                return item;
            }
        },
        computed: {
            tasks() {
                return this.isLoading ? [] : this.$store.state['problem'].listTasks;
            },
            routeToProblem() {
                return this.$store.state.problem.edit;
            },
            typeSteps() {
                return this.$store.state.problem.typeSteps;
            },
            analysisTypes() {
                return this.$store.state.problem.analysisTypes;
            }
        }
    }
</script>
